/**
 * Type definition for input reader event codes.
 *
 * Maps IoTS input event codes to their string representations used in the UI.
 * These codes represent different types of button presses and scroll wheel rotations
 * for devices with input capabilities (buttons, remote controls, dimmers with rotary encoders).
 *
 * @property {string} S - Short press (single click)
 * @property {string} SS - Double short press (double click)
 * @property {string} SSS - Triple short press (triple click)
 * @property {string} L - Long press for buttons; scroll left/up for scroll wheels
 * @property {string} SL - Short press followed by long press
 * @property {string} LS - Long press followed by short press
 * @property {string} [R] - Scroll right/down direction (scroll wheel only)
 */
export type InputReadersEventsType = {
	S: string;
	SS: string;
	SSS: string;
	L: string;
	SL: string;
	LS: string;
	R?: string;
};

/**
 * Maps IoTS input reader event codes to UI display identifiers.
 *
 * This mapping is used to convert backend event codes into visual indicators
 * displayed in the UI (e.g., dots representing number of presses).
 *
 * Special handling:
 * - 'L' has dual meaning: long press for buttons, scroll left/up for scroll wheels
 * - 'R' represents scroll right/down and uses 'one' as a visual indicator
 *
 * @type {InputReadersEventsType}
 */
export const mappedInputReaderEvent: InputReadersEventsType = {
	S: 'one',
	SS: 'two',
	SSS: 'three',
	L: 'long',
	SL: 'short-long',
	LS: 'long-short',
	R: 'one',
};
